import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { SessionStore, SessionState } from './session.store';

@Injectable({ providedIn: 'root' })
export class SessionQuery extends Query<SessionState> {

    selectUser$ = this.select('user');

    constructor(protected store: SessionStore) {
        super(store);
    }

    get isLoggedIn(): boolean {
        return !!this.getValue().user;
      }


    hasAnyAuthority(authorities: string[] | string, inverted = false): boolean {
        const currentUser = this.getValue().user;
        if (!currentUser) {
          return false;
        }
        if (!Array.isArray(authorities)) {
          authorities = [authorities];
        }
        return currentUser.authorities.some((authority: string) => inverted ? !authorities.includes(authority) : authorities.includes(authority));
      }

}